module.exports = __webpack_public_path__ + "static/media/post.9f47f568.png";